import styled from "styled-components";

const ModalBootstrap = ({
  title,
  closeModal,
  submitButton,
  component,
  submitText,
  submitFunc,
  html
}) => {
  return (
    <>
      <Container
        className="modal"
        tabindex="-1"
        role="dialog"
      >
        <Modal className="modal-dialog  modal-dialog-centered" role="document">
          <Content className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title heading">{title}</h5>
              <ButtonContainer>
                <Button
                  type="button"
                  className="btn btn-dark"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                >
                  <span aria-hidden="true">&times;</span>
                </Button>
              </ButtonContainer>
            </div>
            <Body className="modal-body">{component} {html && <span dangerouslySetInnerHTML={{ __html: html }}></span>}</Body>
            <div style={{ display: submitButton ? "block" : "none" }}>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={submitFunc}
                >
                  {submitText}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </Content>
        </Modal>
      </Container>
    </>
  );
};

export default ModalBootstrap;

const Container = styled.div`
  // display: ${(props) => (props?.display ? "block" : "none")};
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  background-color: rgba(0, 0, 0, 0.5);
`;
const Modal = styled.div`
  position: absolute;    // ← Changed from relative to absolute
  display: flex;         // ← Changed from table to flex
  flex-direction: column;
  overflow-y: auto;
  width: auto;
  min-width: 300px;
  max-width: 90vw;
  max-height: 90vh;
`;
const Content = styled.div`
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  border-radius: 8px;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 8px 1px #00eaff;
`;
const Body = styled.div`
  display: flex;
  justify-content: center;
`;
const ButtonContainer = styled.div`
  /* background-color: rgba(0,0,0); */
  aspect-ratio: 1/1;
  font-size: larger;
  border-radius: 8px;
  height: 35px;
  width: 35px;
`;
const Button = styled.button`
  /* background-color: rgba(0,0,0); */
  font-size: larger;
  color: white;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 8px;
  line-height: 0;
`;
